// extracted by mini-css-extract-plugin
export var card = "BlogPostListingItem-module--card--f49bb";
export var cardContent = "BlogPostListingItem-module--cardContent--732ed";
export var cardContentExtra = "BlogPostListingItem-module--cardContentExtra--c06e9";
export var cardHeader = "BlogPostListingItem-module--cardHeader--8a31c";
export var category = "BlogPostListingItem-module--category--b27ed";
export var meta = "BlogPostListingItem-module--meta--f0ad8";